import { STAFF_PATHS } from '../../../../_configuration';

// Routes where a calibration nudge would interrupt an active evaluation, or point the user
// at a page they are already on. The poller suppresses the prompt on any of these.
const SCORING_SURFACE_PREFIXES = ['/evaluate', '/check-in', STAFF_PATHS.ASSIGNMENTS, '/upcoming'];

// True when `pathname` is (or is under) one of the scoring surfaces above.
export const isScoringSurfacePath = (pathname: string): boolean =>
  SCORING_SURFACE_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
  );
